export interface BiteReportAccess {
  allowed: boolean;
  kind: 'admin' | 'complimentary' | 'single' | 'monthly' | 'locked' | 'free';
  expiresAt: string | null;
}

export interface BiteSubscription {
  customerId?: string;
  paidThrough: string | null;
  cancelAtPeriodEnd: boolean;
}

export const BITE_MONTHLY_TERMS = '가입 시 선택한 가격으로 매월 자동 결제되며 언제든 해지할 수 있습니다. 구독 크레딧은 매월 300으로 초기화되고 이용 기간 종료 시 소멸합니다. 별도 충전 크레딧과 소장한 보고서 및 캐릭터 카드는 유지됩니다.';
